import { useEffect } from "react";

/** Adds `se-scroll-open` to <html> while mounted (see speakEasy.css). */
export default function useUnlockPageScroll() {
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add("se-scroll-open");
    return () => html.classList.remove("se-scroll-open");
  }, []);
}
